// extracted by mini-css-extract-plugin
module.exports = {"inputsborder":"styles_inputsborder__3bIkl"};